//#region src/utils/string.ts
var e = (e) => {
	if (!e) return "";
	for (let t = 1; t < e.length + 1; t++) if (e[t - 1].toLowerCase() !== e[t - 1].toUpperCase()) return e.slice(0, t).toUpperCase() + e.slice(t).toLowerCase();
	return e;
}, t = (e, t = 3) => {
	let n = e.toString(), r = n.split("").reverse();
	if (t <= 0) return n;
	for (let e = t; e < r.length; e += t) r.splice(e, 0, " "), e++;
	return r.reverse().join("");
}, n = (e) => e.split("").reduce((e, t) => {
	let n = (e << 5) - e + t.charCodeAt(0);
	return n & n;
}, 0);
//#endregion
export { e as capitaliseStr, n as getHashCode, t as insertSpacesInStr };
